import React from 'react';
import bemClass from '@upsales/components/Utils/bemClass';
import { Icon, Tooltip, Text, DropDownMenu, DropdownContainer } from '@upsales/components';
import DropdownRow from '@upsales/components/DropdownRow';

import './BouncyThumbtack.scss';

interface Company {
	clientId: number;
	name: string;
	pinned: boolean;
	eventId?: number;
}

interface Props {
	pinned: boolean;
	onToggle: (v: boolean) => void;
	pinnedTooltip: string;
	unPinnedTooltip: string;
	tooltipPosition?: React.ComponentProps<typeof Tooltip>['position'];
	tooltipDistance?: React.ComponentProps<typeof Tooltip>['distance'];
	size?: GetProp<typeof Text, 'size'>;
	companies?: Company[];
	onPinCompany?: (companyId: number, companyName: string) => void;
}

export const BouncyThumbtack: React.FC<Props> = ({
	pinned,
	onToggle,
	pinnedTooltip,
	unPinnedTooltip,
	tooltipPosition = 'top',
	tooltipDistance = 25,
	companies,
	onPinCompany,
	size
}) => {
	const classes = new bemClass('BouncyThumbtack');

	// If we have multiple companies and a pin handler, show dropdown
	if (companies && companies.length > 1 && onPinCompany) {
		return (
			<div className={classes.b()}>
				{pinned ? (
					<Tooltip title={pinnedTooltip} position={tooltipPosition} distance={tooltipDistance}>
						<Text>
							<Icon name="thumbtack-pinned" onClick={() => onToggle(false)} />
						</Text>
					</Tooltip>
				) : (
					<DropDownMenu
						arrowed
						// @ts-ignore
						align="center"
						verticalAlign="bottom"
						renderTrigger={(expanded, setExpanded) => (
							<Tooltip title={unPinnedTooltip} position={tooltipPosition} distance={tooltipDistance}>
								<Text>
									<Icon
										className={classes.elem('inactive').b()}
										name="thumbtack"
										onClick={e => {
											e.preventDefault();
											e.stopPropagation();
											setExpanded(e);
										}}
									/>
								</Text>
							</Tooltip>
						)}
					>
						<DropdownContainer>
							{companies.map(company => (
								<DropdownRow
									key={company.clientId}
									title={company.name}
									icon="building"
									onClick={() => {
										onPinCompany(company.clientId, company.name);
									}}
								/>
							))}
						</DropdownContainer>
					</DropDownMenu>
				)}
			</div>
		);
	}

	// Default behavior for single company or no companies
	return (
		<div className={classes.b()}>
			{pinned ? (
				<Tooltip title={pinnedTooltip} position={tooltipPosition} distance={tooltipDistance}>
					<Text size={size}>
						<Icon name="thumbtack-pinned" onClick={() => onToggle(false)} />
					</Text>
				</Tooltip>
			) : (
				<Tooltip title={unPinnedTooltip} position={tooltipPosition} distance={tooltipDistance}>
					<Text size={size}>
						<Icon
							className={classes.elem('inactive').b()}
							name="thumbtack"
							onClick={() => onToggle(true)}
						/>
					</Text>
				</Tooltip>
			)}
		</div>
	);
};

export default BouncyThumbtack;
